/** ノードにホバーしたときのツールチップ（docs/06_ui-ux.md 3 章） */
import { el } from '../layout';

export interface TooltipModel {
  title: string;
  color: string;
  lines: string[];
}

export function createTooltip(host: HTMLElement): {
  show(m: TooltipModel, x: number, y: number): void;
  hide(): void;
} {
  const root = el('div', 'tooltip');
  root.hidden = true;
  host.appendChild(root);
  return {
    show(m, x, y) {
      const title = el('div', 'tooltip__title', m.title);
      title.style.setProperty('--tooltip-color', m.color);
      root.replaceChildren(title, ...m.lines.map((l) => el('div', 'tooltip__line', l)));
      root.hidden = false;
      const hostRect = host.getBoundingClientRect();
      const w = root.offsetWidth;
      const h = root.offsetHeight;
      const left = Math.min(x + 16, hostRect.width - w - 8);
      const top = y + 16 + h > hostRect.height ? y - h - 12 : y + 16;
      root.style.transform = `translate(${left}px, ${top}px)`;
    },
    hide() {
      root.hidden = true;
    },
  };
}
